import React from 'react';
import { styled } from '@compiled/react';
import { Field as AkField, ErrorMessage as AkErrorMessage, RequiredAsterisk } from '@atlaskit/form';
import CalendarIcon from '@atlaskit/icon/core/calendar';
import AkTextField from '@atlaskit/textfield';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { ff } from '@atlassian/jira-feature-flagging';
import { injectIntlV2 as injectIntl } from '@atlassian/jira-intl/src/v2/inject.tsx';
import type { Intl } from '@atlassian/jira-shared-types/src/general.tsx';
import { CALENDAR_NAME } from '../../../../../common/ui/constants.tsx';
import messages from './messages';
import { onValidate, EMPTY_NAME } from './utils';

type Props = Intl & {
	defaultName: string;
};

const Name = ({ intl: { formatMessage }, defaultName }: Props) => {
	if (ff('fix-jsmca11y-994-issue')) {
		return (
			<Wrapper>
				<p aria-hidden="true">
					{formatMessage(messages.requiredField)}
					<RequiredAsterisk />
				</p>
				<AkField
					name={CALENDAR_NAME}
					label={formatMessage(messages.calendarName)}
					defaultValue={defaultName}
					// @ts-expect-error - TS2322 - Type '(newValue: string) => "EMPTY_NAME" | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
					validate={onValidate}
					isRequired
					data-testid="servicedesk-sla-settings.ui.calendars.editable.fields.name.test"
				>
					{({ fieldProps, error }) => (
						<Wrapper>
							<AkTextField
								data-test-id="servicedesk-sla-settings.ui.calendars.editable.fields.name.name-field"
								{...fieldProps}
								aria-label={formatMessage(messages.placeHolder)}
								placeholder={formatMessage(messages.placeHolder)}
							/>
							{error === EMPTY_NAME && (
								<AkErrorMessage>{formatMessage(messages.emptyError)}</AkErrorMessage>
							)}
						</Wrapper>
					)}
				</AkField>
			</Wrapper>
		);
	}
	return (
		<AkField
			name={CALENDAR_NAME}
			defaultValue={defaultName}
			// @ts-expect-error - TS2322 - Type '(newValue: string) => "EMPTY_NAME" | undefined' is not assignable to type '(value: string | undefined, formState: Object, fieldState: Meta) => string | void | Promise<string | void>'.
			validate={onValidate}
			data-testid="servicedesk-sla-settings.ui.calendars.editable.fields.name.test"
		>
			{({ fieldProps, error }) => (
				<Inline>
					{}
					<CalendarIcon
						LEGACY_primaryColor={token('color.icon', colors.N500)}
						LEGACY_size="large"
						label=""
						color="currentColor"
					/>
					<Wrapper>
						<AkTextField
							data-test-id="servicedesk-sla-settings.ui.calendars.editable.fields.name.name-field"
							{...fieldProps}
							aria-label={formatMessage(messages.placeHolder)}
							placeholder={formatMessage(messages.placeHolder)}
						/>
						{error === EMPTY_NAME && (
							<AkErrorMessage>{formatMessage(messages.emptyError)}</AkErrorMessage>
						)}
					</Wrapper>
				</Inline>
			)}
		</AkField>
	);
};

export const NameField = injectIntl(Name);

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Inline = styled.div({
	display: 'flex',
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const Wrapper = styled.div({
	flex: 1,
});
